module.exports = {"pt-BR":{"tableSelectionField":{"all":"Todos","none":"Nenhum","placeholder":"Selecionar"}}}